export default "__VITE_ASSET__580a27ba__"